import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  message: 'Workflow execution stopped',
  reason: 'user_requested'
};

export default defaults;
